<script>
import Modal from '@/components/modal.vue';
import { useCounterStore } from '@/store/counter';
import { mapActions, mapState } from 'pinia';

export default {
  props:{
    selectClass: String,
    showAddIcon: {
      type : Boolean,
      default: false
    },
  },
  components: {
    Modal
  },
  data() {
    return {
      openModal: false,
      isCheckRange: false,
      isCheckRange2: true,
      checkSelect: false,
      dataDel: [],
      searchQuery: '',
      selectedColumn: 'all',
      columns: ['all', 'varietas', 'taraf', 'ulangan'],
      checkSort: {
        varietas: '',
        taraf: '',
        ulangan: '',
        sensorIndex: ''
      },
      pageSize: 5,
      currentPage: 1,
      sortedData: [],
      startIndex: 0,
      endIndex: 5,
      downloadSetup: {
        startDate: '',
        endDate: '',
        plantOption: ''
      }
    };
  },
  methods: {
    ...mapActions(useCounterStore, [
      'getRealtimeSensor',
      'getAllPlanst',
      'delPlant',
      'getMemberGroup',
      'downloadExcel'
    ]),
    alertCall(){
      Swal.fire({
        icon: "error",
        title: "Please select at least one",
        confirmButtonColor: "#5229d9"
      });
    },
    async downloadSetupHandler(){
      if(this.dataDel.length === 0){
        this.alertCall()
      }else{
        console.log(this.dataDel)
        await this.downloadExcel(this.downloadSetup.startDate,this.downloadSetup.endDate,this.dataDel,this.isCheckRange2?1:2)
      }
    },
    handlerAddClass(){
      this.$emit('handlerAddClass', true)
    },
    statusFunc(data, taraf){
      if(this.dataRealtime?.[data]>(taraf+5)){
        return 'High'
      }else if(this.dataRealtime?.[data]>(taraf-5)){
        return 'Medium'
      }else {
        return 'Low'
      }
    },
    sortHandler(value) {
      if (value === 'varietas') {
        this.checkSort.varietas = this.toggleSortDirection(this.checkSort.varietas);
        this.checkSort.taraf = '';
        this.checkSort.ulangan = '';
        this.checkSort.sensorIndex = '';
        this.sortData(this.checkSort.varietas, 'varietas');
      } else if (value === 'taraf') {
        this.checkSort.taraf = this.toggleSortDirection(this.checkSort.taraf);
        this.checkSort.varietas = '';
        this.checkSort.ulangan = '';
        this.checkSort.sensorIndex = '';
        this.sortData(this.checkSort.taraf, 'taraf');
      } else if (value === 'ulangan') {
        this.checkSort.ulangan = this.toggleSortDirection(this.checkSort.ulangan);
        this.checkSort.varietas = '';
        this.checkSort.taraf = '';
        this.checkSort.sensorIndex = '';
        this.sortData(this.checkSort.ulangan, 'ulangan');
      } else if (value === 'sensor') {
        this.checkSort.sensorIndex = this.toggleSortDirection(this.checkSort.sensorIndex);
        this.checkSort.ulangan = '';
        this.checkSort.varietas = '';
        this.checkSort.taraf = '';
        this.sortData(this.checkSort.sensorIndex, 'sensorIndex');
      }
    },
    toggleSortDirection(currentSort) {
      if (currentSort === 'asc') return 'dsc';
      if (currentSort === 'dsc') return '';
      return 'asc';
    },
    sortData(sortDirection, column) {
      if (!sortDirection) {
        this.sortedData = [...this.sortedData].sort((a, b) => a.id - b.id);
      } else {
        this.sortedData = [...this.sortedData].sort((a, b) => {
          let fieldA = a[column];
          let fieldB = b[column];
          const isNumber = typeof fieldA === 'number' && typeof fieldB === 'number';

          if (!isNumber) {
            fieldA = fieldA?.toString().toLowerCase();
            fieldB = fieldB?.toString().toLowerCase();
          }

          if (sortDirection === 'asc') {
            return isNumber ? fieldA - fieldB : fieldA.localeCompare(fieldB);
          } else if (sortDirection === 'dsc') {
            return isNumber ? fieldB - fieldA : fieldB.localeCompare(fieldA);
          }
        });
      }
      this.currentPage = 1;
      this.paginateData();
    },
    updatePageSize(event) {
      this.pageSize = parseInt(event.target.value);
      this.currentPage = 1;
      this.paginateData();
    },
    paginateData() {
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
      }else{
        this.paginatedData
      }
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.paginateData();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.paginateData();
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.paginateData();
      }
    },
    async deletePlantHandler(clas){
      if(this.dataDel.length > 0){
        if(clas){
          this.$emit('dataPlant', this.dataDel)
          this.checkSelect=false
        }else{
          const res = await this.delPlant(this.dataDel)
          if(res){
            if(this.$route.params.id){
              await this.getMemberGroup(this.$route.params.id)
            }else{
              await this.getAllPlanst()
            }
            this.paginateData()
            this.dataDel=[]
          }
        }
      }else{
        this.alertCall()
      }
    }
  },
  computed: {
    ...mapState(useCounterStore, ['dataAllPlants', 'dataRealtime']),
    filteredData() {
      let filtered = this.dataAllPlants;
      if (this.searchQuery !== '') {
        filtered = this.dataAllPlants.filter((item) => {
          if (this.selectedColumn === 'all') {
            // Search across all columns
            return this.columns.some((col) =>
              String(item[col])?.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
          } else {
            // Search in the specific selected column
            return String(item[this.selectedColumn])
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase());
          }
        });
      }
      //this.currentPage=1
      this.sortedData = filtered
      return filtered;
    },
    totalPages() {
      return Math.ceil(this.filteredData.length / this.pageSize); // Calculate total pages
    },
    paginatedData() {
      this.startIndex = (this.currentPage - 1) * this.pageSize;
      this.endIndex = this.startIndex + this.pageSize;
    },
  },
  watch: {
    dataAllPlants() {
      if(this.sortedData.length===0){
        this.currentPage = 1
      }
      this.paginateData();
    },
    searchQuery() {
      this.currentPage = 1;
      this.paginateData();
    },
    checkSelect(newVal){
      console.log(this.checkSelect)
      if(newVal){
        this.dataDel = []
        this.sortedData.map((item,i )=>{
          if(i >= this.startIndex && i < this.endIndex){
            this.dataDel.push(item.id)
          }
        })
      }else{
        this.dataDel = []
      }
    },
    selectClass(newval){
      if(newval){
        this.dataDel=[]
      }
    }
  },
};
</script>

<template>
  <div
      class="mt-2 bg-white dark:bg-gray-800 p-5 w-full rounded-md box-border border dark:border-gray-700"
    >
    <div class="flex justify-between">
      <div>
        <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">
          Plant List
        </h2>
        <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">
            {{ selectClass }}
        </h2>
      </div>
      <div class="lg:flex gap-2 sm:block;items-end ">
        <div class="text-gray-600 dark:text-gray-300 outline-none focus:outline-none">
          <div class="relative flex">
                <select v-model="selectedColumn"
                    class="bg-white dark:bg-gray-800 w-20 h-10 px-1 rounded-l-full text-sm focus:outline-none outline-none border-2 border-gray-500 dark:border-gray-600 border-r-1 cursor-pointer max-h-10 overflow-y-hidden">
                    <option v-for="(item, index) in columns" :key="index" class="font-medium cursor-pointer" :value="item">{{ item }}</option>
                </select>
                <input 
                    v-model="searchQuery"
                    type="search" 
                    name="search"
                    placeholder="Search"
                    class="bg-white dark:bg-gray-800 h-10 flex px-5 w-full rounded-r-full text-sm focus:outline-none border-2 border-l-0 border-gray-500 dark:border-gray-600"
                    autocomplete="off" 
                    spellcheck="false" 
                    required 
                    step="any" 
                    autocapitalize="none" 
                    autofocus />
                <button 
                    v-on:click="paginateData" 
                    class="absolute inset-y-0 right-0 mr-2 flex items-center px-2">
                    <svg 
                        class="h-4 w-4 fill-current dark:text-white" 
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" 
                        version="1.1" id="Capa_1" x="0px" y="0px"
                        viewBox="0 0 56.966 56.966" 
                        xml:space="preserve" 
                        width="512px" 
                        height="512px">
                            <path
                                d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
                    </svg>
                </button>
          </div>
        </div>
        <div v-if="showAddIcon && selectClass !== 'All'" v-on:click="handlerAddClass" class="cursor-pointer select-none hover:scale-110 transition-transform duration-300">
          <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14m-7 7V5"/>
          </svg>
        </div>
        <div v-on:click="dataDel.length>0?openModal=true:alertCall()" class="cursor-pointer hover:scale-110 transition-transform duration-300" >
          <svg class="p-auto w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 15v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-2m-8 1V4m0 12-4-4m4 4 4-4"/>
          </svg>
        </div>
        <div v-if="showAddIcon" v-on:click="deletePlantHandler(selectClass)" class="cursor-pointer select-none hover:scale-110 transition-transform duration-300">
          <svg width="24" height="24" viewBox="0 0 1024 1024" class="icon"  version="1.1" xmlns="http://www.w3.org/2000/svg">
            <path d="M917.333333 640V384c0-46.933333-38.4-85.333333-85.333333-85.333333H192c-46.933333 0-85.333333 38.4-85.333333 85.333333v256c0 46.933333 38.4 85.333333 85.333333 85.333333h640c46.933333 0 85.333333-38.4 85.333333-85.333333zM192 384h640v256H192V384z" fill="#90CAF9" />
            <path d="M810.666667 810.666667m-213.333334 0a213.333333 213.333333 0 1 0 426.666667 0 213.333333 213.333333 0 1 0-426.666667 0Z" fill="#F44336" /><path d="M923.946667 878.528l-45.226667 45.269333-181.013333-180.992 45.248-45.269333z" fill="#FFFFFF" />
            <path d="M742.805333 923.946667l-45.269333-45.226667 180.992-181.013333 45.269333 45.248z" fill="#FFFFFF" />
          </svg>
        </div>
        <div class="h-9">
          <div class="cursor-pointer hover:scale-110 transition-transform duration-300" v-on:click="deletePlantHandler()">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="red">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapping-table overflow-x-auto mt-5">
      <table
        class="w-full text-sm text-left text-gray-500 dark:text-gray-400 lg:overflow-auto overflow-x-scroll"
      >
        <thead
          class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
        >
          <tr>
            <th
              scope="col"
              class="uppercase px-1 py-3"
            >
              No
            </th>
            <th
              scope="col"
              class="uppercase px-2 py-3"
            >
            <div class="flex justify-between cursor-pointer select-none" v-on:click="sortHandler('varietas')">
              Varietas
              <svg v-if="checkSort.varietas === 'asc'" class="w-4 h-4 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v13m0-13 4 4m-4-4-4 4"/>
              </svg>
              <svg v-if="checkSort.varietas === 'dsc'" class="w-4 h-4 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19V5m0 14-4-4m4 4 4-4"/>
              </svg>
            </div>
            </th>
            <th
              scope="col"
              class="uppercase px-2 py-3"
            >
            <div class="flex justify-between cursor-pointer select-none" v-on:click="sortHandler('sensor')">
              Sensor
              <svg v-if="checkSort.sensorIndex === 'asc'" class="w-4 h-4 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v13m0-13 4 4m-4-4-4 4"/>
              </svg>
              <svg v-if="checkSort.sensorIndex === 'dsc'" class="w-4 h-4 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19V5m0 14-4-4m4 4 4-4"/>
              </svg>
            </div>
            </th>
            <th
              scope="col"
              class="uppercase px-2 py-3"
            >
            <div class="flex justify-between cursor-pointer select-none" v-on:click="sortHandler('taraf')">
              Taraf Cekaman
              <svg v-if="checkSort.taraf === 'asc'" class="w-4 h-4 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v13m0-13 4 4m-4-4-4 4"/>
              </svg>
              <svg v-if="checkSort.taraf === 'dsc'" class="w-4 h-4 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19V5m0 14-4-4m4 4 4-4"/>
              </svg>
            </div>
            </th>
            <th
              scope="col"
              class="uppercase px-2 py-3"
            >
            <div class="flex justify-between cursor-pointer select-none" v-on:click="sortHandler('ulangan')">
              Ulangan
              <svg v-if="checkSort.ulangan === 'asc'" class="w-4 h-4 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v13m0-13 4 4m-4-4-4 4"/>
              </svg>
              <svg v-if="checkSort.ulangan === 'dsc'" class="w-4 h-4 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19V5m0 14-4-4m4 4 4-4"/>
              </svg>
            </div>
            </th>
            <th
              scope="col"
              class="uppercase px-2 py-3"
            >
              Status
            </th>
            <th
              scope="col"
              class="uppercase px-2 py-3"
            >
              Humidity
            </th>
            <th
              scope="col"
              class="uppercase px-2 py-3"
            >
            <div class="flex justify-between">
              Action
              <input 
                v-model="checkSelect"
                type="checkbox" 
                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="sortedData.length > 0"
            class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 odd:bg-white even:bg-gray-50"
            v-for="(items, i) in sortedData.slice(startIndex, endIndex)" 
            :key="items.id"
          >
            <td class="px-1 py-2">
              {{ startIndex + i + 1 }}
            </td>
            <td class="px-2 py-2">
              {{ items.varietas }}
            </td>
            <td class="px-2 py-2">
              {{ items.sensorIndex }}
            </td>
            <td class="px-2 py-2">
              {{ items.taraf }}
            </td>
            <td class="px-2 py-2">
              {{ items.ulangan }}
            </td>
            <td class="px-2 py-2">
              {{ statusFunc(items.sensorIndex, items.taraf) }}
            </td>
            <td class="px-2 py-2">
              {{ dataRealtime[items.sensorIndex] }}
            </td>
            <td class="px-2 py-2">
              <div class="flex justify-between items-center">
                <router-link
                  :to="'/plant/' + items.id"
                  type="button"
                  class="focus:outline-none text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-2 py-1.5 mr-1 mb-1"
                >
                  View
                </router-link>
                <input 
                  v-model="dataDel"
                  type="checkbox" 
                  :value="items.id" 
                  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <p v-if="sortedData.length === 0" class="text-center text-gray-900 dark:text-gray-200 mt-1">No Data Found</p>
    </div>
    <div>
      <div class="flex justify-center items-center dark:bg-gray-800">
        <div class="p-2 border-t dark:border-gray-700  w-full">
            <nav role="navigation" aria-label="Pagination Navigation" class="flex items-center justify-between">
                <div class="flex justify-between items-center flex-1 lg:hidden">
                    <div class="w-10">
                        <button title="Previous" type="button"
                        class=" flex items-center justify-center rounded-full relative outline-none hover:bg-gray-500/5 disabled:opacity-70 disabled:cursor-not-allowed disabled:pointer-events-none text-yellow-500 focus:bg-yellow-500/10 dark:hover:bg-gray-300/5 w-10 h-10"
                        rel="prev"
                        v-on:click="previousPage"
                        >
                        <span class="sr-only">
                            Previous
                        </span>
                        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            stroke-width="3" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"></path>
                        </svg>
                    </button>
                    </div>
        
                    <div class="flex items-center gap-2 rtl:space-x-reverse">
                        <select v-model="pageSize" @change="updatePageSize"
                            class="h-8 text-sm px-2 leading-none transition duration-75 border-gray-300 rounded-lg shadow-sm outline-none focus:border-yellow-500 focus:ring-1 focus:ring-inset focus:ring-yellow-500 dark:text-white dark:bg-gray-700 dark:border-gray-600 dark:focus:border-yellow-500">
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="450">All</option>
                        </select>
        
                        <span class="text-sm font-medium dark:text-white">
                            per page
                        </span>
                    </div>
        
                    <div class="w-10">
                        <button title="Next" type="button"
                        class="flex items-center justify-center rounded-full relative outline-none hover:bg-gray-500/5 disabled:opacity-70 disabled:cursor-not-allowed disabled:pointer-events-none text-yellow-500 focus:bg-yellow-500/10 dark:hover:bg-gray-300/5 w-10 h-10"
                        rel="next"
                        v-on:click="nextPage"
                        >
                        <span class="sr-only">
                            Next
                        </span>
        
                        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            stroke-width="3" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"></path>
                        </svg>
                    </button>
                    </div>
                </div>
        
                <div class="hidden flex-1 items-center lg:grid grid-cols-3">
                    <div class="flex items-center">
                        <div class="pl-2 text-sm font-medium dark:text-white">
                            Showing {{ sortedData.length > 0 ? (pageSize * (currentPage - 1) + 1) : 0 }} to {{ Math.min(pageSize * currentPage, sortedData.length)}} of {{ sortedData.length }} results
                        </div>
                    </div>
        
                    <div class="flex items-center justify-center">
                        <div
                            class="flex items-center space-x-2 filament-tables-pagination-records-per-page-selector rtl:space-x-reverse">
                            <label>
                            <select v-model="pageSize" @change="updatePageSize"
                                class="h-8 text-sm pr-8 leading-none transition duration-75 border-gray-300 rounded-lg shadow-sm outline-none focus:border-yellow-500 focus:ring-1 focus:ring-inset focus:ring-yellow-500 dark:text-white dark:bg-gray-700 dark:border-gray-600 dark:focus:border-yellow-500">
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="450">All</option>
                            </select>
        
                            <span class="text-sm font-medium dark:text-white">
                                per page
                            </span>
                        </label>
                        </div>
                    </div>
        
                    <div class="flex items-center justify-end">
                        <div class="py-3 border rounded-lg dark:border-gray-600">
                            <ol
                                class="flex items-center text-sm text-gray-500 divide-x rtl:divide-x-reverse divide-gray-300 dark:text-gray-400 dark:divide-gray-600">
                                <li>
                                    <button type="button" v-on:click="previousPage"
                                    class="relative flex items-center justify-center font-medium min-w-[2rem] px-1.5 h-8 -my-3 rounded-md outline-none hover:bg-gray-500/5 focus:bg-yellow-500/10 focus:ring-2 focus:ring-yellow-500 dark:hover:bg-gray-400/5 transition text-yellow-600"
                                    aria-label="Previous" rel="prev">
                                    <svg class="w-5 h-5 rtl:scale-x-[-1]" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd"
                                            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                                </li>
                                <li>
                                  <div
                                    class="relative flex items-center justify-center font-medium min-w-[2rem] px-1.5 h-8 -my-3 rounded-md outline-none transition text-yellow-600 filament-tables-pagination-item-active focus:underline bg-yellow-500/10">
                                    <span>{{ currentPage }}</span>
                                </div>
                                </li>
                                <li>
                                    <button type="button" v-on:click="nextPage"
                                    class="relative flex items-center justify-center font-medium min-w-[2rem] px-1.5 h-8 -my-3 rounded-md outline-none hover:bg-gray-500/5 focus:bg-yellow-500/10 focus:ring-2 focus:ring-yellow-500 dark:hover:bg-gray-400/5 transition text-yellow-600"
                                    aria-label="Next" rel="next">
                                    <svg class="w-5 h-5 rtl:scale-x-[-1]" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd"
                                            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
      </div>
    </div>
    <Modal
      title="Download Setup"
      btnTextSubmit="Download"
      btnText="Add Group"
      btnType="submit"
      :btnShow="false"
      :isOpenEx="openModal"
      @updateOpen="openModal=false"
      @submitForm="downloadSetupHandler"
    >
      <template v-slot:body>
        <div class="space-y-5 pb-5">
          <div class="space-y-3">
            <div class="flex gap-2 justify-between">
              <div class="flex-1 w-50">
                <p>Start Date</p>
                <input
                  type="date"
                  required
                  placeholder=""
                  class="p-2 dark:[color-scheme:dark] border dark:border-gray-600 dark:bg-gray-700 w-full rounded outline-none"
                  v-model="downloadSetup.startDate"
                />
              </div>
              <div v-if="isCheckRange" class="flex-1 w-50" >
                <p>End Date</p>
                <input
                  type="date"
                  placeholder=""
                  required
                  class="p-2 dark:[color-scheme:dark] border dark:border-gray-600 dark:bg-gray-700 w-full rounded outline-none"
                  v-model="downloadSetup.endDate"
                />
              </div>
            </div>
            <div class="flex items-center justify-between mb-4">
              <div class="items-center flex">
                <input id="default-checkbox" v-model="isCheckRange" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                <label for="default-checkbox" class="ms-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Range Date</label>
              </div>
              <div class="items-center flex">
                <input id="default-checkbox" v-model="isCheckRange2" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                <label for="default-checkbox" class="ms-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Include Temperature</label>
              </div>
            </div>
            <div>
              <h3 class="mb-4 font-semibold text-gray-900 dark:text-white">Plant Option</h3>
              <ul class="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                  <li class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                      <div class="flex items-center ps-3">
                          <input required id="horizontal-list-radio-license" type="radio" v-model="downloadSetup.plantOption" value="selected" name="list-radio" class="ml-10 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                          <label for="horizontal-list-radio-license" class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Selected</label>
                      </div>
                  </li>
                  <li class="w-full dark:border-gray-600">
                      <div class="flex items-center ps-3">
                          <input id="horizontal-list-radio-passport" type="radio" v-model="downloadSetup.plantOption" value="all" name="list-radio" class="ml-10 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                          <label for="horizontal-list-radio-passport" class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">All</label>
                      </div>
                  </li>
              </ul>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>